import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';

import { StyledCard } from '../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { VarmesentralRadio } from '../../common/varmesentralRadio';
import { OppvarmingFormData } from '../../../../types';
import { ServiceSisteToArRadio } from '../../common/serviceSisteToArRadio';
import { VarmesystemBrukCheckboxes } from '../../common/varmesystemBruk';
import { InstallertIOppvarmetRomRadio } from '../../common/installertIOppvarmetRomRadio';
import { InstallasjonsArRadio } from '../../../../../../components/installasjonsArRadio';

import { Fordelingssystem } from './fordelingssystem';

export const Varmesystem = () => {
  const { watch } = useFormContext<OppvarmingFormData>();

  const solfangerKjelSelected = watch('solfanger.selected');
  const oppvarmingBrukSelection = watch('solfanger.value.bruk');
  const showFordelingssystem = oppvarmingBrukSelection?.romoppvarming;

  return (
    <StyledCard isActive={solfangerKjelSelected}>
      <Fragment>
        <InstallasjonsArRadio
          name="solfanger.value.varmesentral"
          translationKeyPrefix="form.oppvarming.solfanger.varmesentral.installasjonsAr" />
        <VarmesentralRadio name="solfanger.value.varmesentral.varmesentralType" />
        <InstallertIOppvarmetRomRadio name="solfanger.value.varmesentral.installertIOppvarmetRom" />

        <InstallasjonsArRadio
          name="solfanger.value"
          translationKeyPrefix="form.oppvarming.solfanger.installasjonsAr" />
        <ServiceSisteToArRadio name="solfanger.value.serviceGjennomfortSiste2Ar" />

        <VarmesystemBrukCheckboxes name="solfanger.value.bruk" />

        {showFordelingssystem && <Fordelingssystem />}
      </Fragment>
    </StyledCard>
  );
};
